module.exports = __webpack_public_path__ + "static/cabify@2x-2bd677a47c202d14d9dc4b9b8d5dec5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/cabify@2x.png
// module id = 2678
// module chunks = 157636680307020